import React, { useState } from "react";
import Sidebar from "./Sidebar";
import Topbar from "./Topbar";

function AppShell({ children }) {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="app-shell">
      <Sidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      <div className="app-content">
        <Topbar onMenuClick={() => setSidebarOpen(true)} />
        <main className="app-main">{children}</main>
      </div>
    </div>
  );
}

export default AppShell;
